import client from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import SettingsStyles from 'components/Settings/SettingsModal.module.scss'
import { useAuth } from 'hooks/UseAuth'
import { useHandbooksDeprecation } from 'hooks/useHandbooksDeprecation'
import { useWorkspace } from 'hooks/useWorkspace'
import { useWorkspaces } from 'hooks/useWorkspaces'
import useIsMounted from 'ismounted'
import { useEffect, useState } from 'react'
import { WorkspaceSettings as SecuritySettingsType } from 'types'
import { SamlSettings } from './SamlSettings/SamlSettings'
import { ScimSettings } from './ScimSettings/ScimSettings'
import Styles from './SecuritySettings.module.scss'
import { WorkspaceAdminForm } from './WorkspaceAdminForm'
import { WorkspaceHandbookForm } from './WorkspaceHandbookForm'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { Spinner } from 'common/Spinner/Spinner'
import { Heading } from 'blaze-ui/Heading/Heading'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { Modal } from 'almanac-ui/Modal'

export const SecuritySettings = () => {
  const auth = useAuth()
  const workspaceId = auth && auth.company_id
  const workspace = useWorkspace(workspaceId)
  const workspaces = useWorkspaces()
  const [workspaceSettings, setSecuritySettings] = useState<SecuritySettingsType>()
  const handbooksDeprecated = useHandbooksDeprecation()
  const isMounted = useIsMounted()
  const { isMobile } = useResponsiveDesign()
  const isSettingsModalUpdateEnabled = useFlipperFlag('settings_modal_update')

  useEffect(() => {
    if (!auth || !workspace) return

    const loadSecuritySettings = async (workspaceKey: string) => {
      const res = await client.getWorkspaceSettings(workspaceKey)
      if (res.type === SUCCESS_RESPONSE_TYPE) {
        isMounted.current && setSecuritySettings(res.data.company)
      }
    }

    loadSecuritySettings(workspace.key)
  }, [workspace, auth, isMounted])

  if (!workspace || !workspaceSettings) return <Spinner className={SettingsStyles.spinner} />

  return (
    <>
      <div className={Styles.settingsSection}>
        {!isMobile && !isSettingsModalUpdateEnabled && (
          <header className={SettingsStyles.subHeader}>
            <Heading level={3}>Security</Heading>
          </header>
        )}
        {!isMobile && isSettingsModalUpdateEnabled && (
          <Modal.Header title="Security" className={SettingsStyles.newHeader} />
        )}
        <WorkspaceAdminForm workspace={workspaceSettings} />
      </div>
      {!handbooksDeprecated && (
        <div className={Styles.settingsSection}>
          <WorkspaceHandbookForm workspace={workspace} workspaces={workspaces} />
        </div>
      )}
      <div className={Styles.settingsSection}>
        <div className={Styles.settingsContent}>
          <div className={Styles.settingsOptions}>
            <SamlSettings workspace={workspaceSettings} />
            <ScimSettings workspace={workspaceSettings} />
          </div>
        </div>
      </div>
    </>
  )
}
